import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBeforeUnload } from 'react-router-dom';

interface IPromptUnsavedChangesProps {
    dirty: boolean;
}
export default function PromptUnsavedChanges(props: IPromptUnsavedChangesProps) {
    const { t } = useTranslation("common");
    const description: string = t("propmtUnsaved.description");

    useBeforeUnload(React.useCallback(() => {
        if (props.dirty) {
            return description;
        }

    }, [props.dirty, description]));

    return null;

}
